import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-cell-renderer',
  templateUrl: './cell-renderer.component.html',
  styleUrls: ['./cell-renderer.component.scss']
})
export class CellRendererComponent implements OnInit {

  params;

  constructor() { }

  ngOnInit() {
  }

  agInit(params): void {
    this.params = params;
  }

  onClick(): void {
    this.params.action(this.params);
  }
}
export type CellAction = (params) => void;
